import util from '../util'

let controller = 'ContaFavorecidos'
export default Object.assign({}, util.GetCrud(controller, null))
